

























import { EventBus } from '@/event-bus';
import BaseFormEdit from "../../models/base.form.edit";
import { Component } from "vue-property-decorator";

@Component({})
export default class Edit extends BaseFormEdit {
  form = { values: {} } as any;

  created() {
    var self = this;
     EventBus.$on('success', function() {
      //@ts-ignore
      self.loadLocaleMessages();
    });
  }
}
